import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, SparklesIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function OfferSection() {
  return <section id="offer" className="w-full bg-[#faf7f2] py-16 md:py-24" data-id="element-121">
      <div className="max-w-4xl mx-auto px-4" data-id="element-122">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} data-id="element-123">
          {/* Special offer container */}
          <div className="relative" data-id="element-124">
            <div className="absolute inset-0 bg-gradient-to-r from-[#d4a853]/20 via-[#f5c542]/10 to-[#d4a853]/20 rounded-3xl blur-xl" data-id="element-125" />
            <div className="relative bg-white border-2 border-[#d4a853] rounded-3xl p-8 md:p-12 shadow-xl" data-id="element-126">
              <div className="flex items-center justify-center gap-2 mb-6" data-id="element-127">
                <SparklesIcon className="w-6 h-6 text-[#d4a853]" data-id="element-128" />
                <span className="font-['DM_Sans'] text-[#d4a853] font-semibold uppercase tracking-wider text-sm" data-id="element-129">
                  Precio Especial de Lanzamiento
                </span>
                <SparklesIcon className="w-6 h-6 text-[#d4a853]" data-id="element-130" />
              </div>

              <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl lg:text-5xl font-bold text-[#0f172a] text-center mb-6" data-id="element-131">
                Recupera Tu Sueño <span className="text-[#d4a853]" data-id="element-132">Hoy</span>
              </h2>

              <p className="font-['DM_Sans'] text-[#64748b] text-lg text-center mb-8 max-w-2xl mx-auto" data-id="element-133">
                Recupera tu salud mental y el sueño de tu familia por menos de
                lo que cuesta una salida a comer.{' '}
                <span className="text-[#0f172a] font-semibold" data-id="element-134">
                  No estás comprando un libro, estás comprando tu derecho a
                  descansar.
                </span>
              </p>

              {/* Price */}
              <div className="text-center mb-8" data-id="element-135">
                <span className="font-['Playfair_Display'] text-3xl md:text-4xl font-bold text-[#94a3b8] line-through mr-3" data-id="element-136">
                  $17
                </span>
                <span className="font-['Playfair_Display'] text-6xl md:text-7xl font-bold text-[#0f172a]" data-id="element-137">
                  $6.39
                </span>
                <span className="font-['DM_Sans'] text-2xl text-[#64748b] ml-2" data-id="element-138">
                  USD
                </span>
                <div className="mt-2" data-id="element-139">
                  <span className="inline-block bg-[#22c55e]/15 text-[#16a34a] font-['DM_Sans'] font-semibold text-sm px-3 py-1 rounded-full" data-id="element-140">
                    ¡Ahorra 62%!
                  </span>
                </div>
              </div>

              {/* Product image */}
              <div className="max-w-sm mx-auto mb-8" data-id="element-141">
                <img src="https://cdn.magicpatterns.com/uploads/v2DJkDeA4Q7ePxM1ZEptrf/heylloyd-image-1772411643963.png" alt="Método Noche en Paz - Guía completa para el sueño infantil" className="w-full h-auto rounded-xl shadow-lg" data-id="element-142" />
              </div>

              {/* CTA */}
              <div className="flex flex-col items-center gap-4" data-id="element-143">
                <CTAButton className="text-xl px-12 py-6" data-id="element-144">
                  ¡QUIERO QUE MI BEBÉ DUERMA HOY!
                </CTAButton>

                <div className="flex items-center gap-2 text-[#64748b]" data-id="element-145">
                  <ShieldCheckIcon className="w-5 h-5 text-[#22c55e]" data-id="element-146" />
                  <span className="font-['DM_Sans'] text-sm" data-id="element-147">
                    Acceso instantáneo después del pago. Seguro y confiable.
                  </span>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}